import { z } from 'zod';
/**
 * Email filter rule schema (AND/OR nested).
 * Same shape used in DB (JSONB), API validation, and FE form.
 */
export const FilterFieldSchema = z.enum(['from', 'to', 'subject', 'body']);
export const FilterMatchSchema = z.enum(['exact', 'contains', 'domain', 'regex']);
export const FilterOperatorSchema = z.enum(['AND', 'OR']);
export const FilterLeafSchema = z.object({
    field: FilterFieldSchema,
    match: FilterMatchSchema,
    value: z.string().min(1),
});
export const FilterGroupSchema = z.lazy(() => z.object({
    operator: FilterOperatorSchema,
    rules: z.array(FilterRuleSchema).min(1),
}));
export const FilterRuleSchema = z.lazy(() => z.union([FilterLeafSchema, FilterGroupSchema]));
export const FilterActionSchema = z.enum([
    'create_task',
    'route_module',
    'inbox',
    'archive',
    'block',
    /** Direct la un om, fara oprire in Triaj. `actionTarget` = emailul lui. */
    'assign_direct',
]);
export function evaluateRule(rule, msg) {
    if ('operator' in rule) {
        if (rule.operator === 'AND')
            return rule.rules.every((r) => evaluateRule(r, msg));
        return rule.rules.some((r) => evaluateRule(r, msg));
    }
    const value = msg[rule.field] ?? '';
    switch (rule.match) {
        case 'exact':
            return value === rule.value;
        case 'contains':
            return value.toLowerCase().includes(rule.value.toLowerCase());
        case 'domain': {
            if (rule.field !== 'from' && rule.field !== 'to')
                return false;
            /*
              Adresa vine in doua forme: goala (`no-reply@trendyol.com`) sau cu numele afisat
              (`Trendyol <seller@trendyol.com>`). A doua e cea obisnuita, si pe ea potrivirea cadea:
              `endsWith('trendyol.com')` e fals cand sirul se termina cu `>`.
      
              Regula lui Victor pentru trendyol n-ar fi prins nimic in productie. A iesit la iveala
              dintr-un test scris cu ambele forme, nu din folosire — un filtru care nu prinde nimic
              arata exact ca unul care n-a avut ce prinde.
            */
            const brut = value.toLowerCase();
            const adresa = (/<([^>]+)>/.exec(brut)?.[1] ?? brut).trim();
            const domeniu = rule.value.toLowerCase().replace(/^@/, '');
            return adresa.endsWith(`@${domeniu}`) || adresa.endsWith(`.${domeniu}`) || adresa === domeniu;
        }
        case 'regex':
            try {
                return new RegExp(rule.value, 'i').test(value);
            }
            catch {
                return false;
            }
    }
}
//# sourceMappingURL=filters.js.map